import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "UiAppbar__in" }
const _hoisted_2 = {
  key: 0,
  class: "UiAppbar__left"
}
const _hoisted_3 = { class: "UiAppbar__content" }
const _hoisted_4 = { class: "UiAppbar__title" }
const _hoisted_5 = { class: "UiAppbar__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.rootClasses)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.left || _ctx.showLeft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "left")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "right")
      ])
    ])
  ], 2))
}